import { Injectable } from '@angular/core';
import { GungTitleService } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class CarLinerGungTitleService extends GungTitleService {
  public getDefaultTitle(): string {
    let title = this.environment.websiteTitle || this.environment['projectName'] || this.titleService.getTitle();
    switch (this.environment['projectName']) {
      case 'caroliner':
        title = 'Car-O-Liner SIM';
        break;
      case 'thailand':
        title = 'Car-O-Liner APAC SIM';
        break;
      case 'blackhawk':
        title = 'Blackhawk SIM';
        break;
      case 'josam':
        title = 'Digital Sales Catalogue - JOSAM';
        break;
      default:
        break;
    }
    return title;
  }
}
